<template>
    <div class="login-container">
        <h2>Admin Login</h2>
        <div class="form-group">
            <label for="username">Username:</label>
            <input
                type="text"
                v-model="username"
                id="username"
                required
                :disabled="loading"
                @keyup.enter="handleLogin"
            />
        </div>
        <div class="form-group">
            <label for="password">Password:</label>
            <input
                type="password"
                v-model="password"
                id="password"
                required
                :disabled="loading"
                @keyup.enter="handleLogin"
            />
        </div>
        <el-button type="primary" @click="handleLogin" :loading="loading" style="width: 100%">
            {{ loading ? 'Logging in...' : 'Login' }}
        </el-button>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
</template>

<script>
import { login } from '../api/auth';
import { setToken, setUser, isAuthenticated } from '../utils/auth';

export default {
    name: 'UserLogin',
    data() {
        return {
            username: "",
            password: "",
            errorMessage: "",
            loading: false
        };
    },
    mounted() {
        if (isAuthenticated()) {
            this.$router.push('/');
        }
    },
    methods: {
        async handleLogin() {
            if (this.loading) return;

            this.loading = true;
            this.errorMessage = "";

            try {
                const result = await login(this.username, this.password);

                if (result.success) {
                    setToken(result.token);
                    setUser(result.user);
                    window.dispatchEvent(new CustomEvent('auth-change'));
                    this.$message.success('Login successful!');
                    this.$router.push('/');
                } else {
                    this.errorMessage = result.error || 'Login failed, please try again';
                }
            } catch (e) {
                console.error('Login error:', e);
                this.errorMessage = 'Network error, please try again later';
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.login-container {
    max-width: 400px;
    margin: 100px auto;
    padding: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.login-container h2 {
    text-align: center;
    margin-bottom: 24px;
    color: #333;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #606266;
    font-size: 14px;
}

.form-group input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s;
    box-sizing: border-box;
}

.form-group input:focus {
    outline: none;
    border-color: #409eff;
}

.form-group input:disabled {
    background-color: #f5f7fa;
    cursor: not-allowed;
}

.el-button {
    margin-top: 10px;
}

.error {
    color: #f56c6c;
    text-align: center;
    margin-top: 16px;
    font-size: 14px;
}
</style>
